import { Serializable } from './Serializable';
import { Utils } from '../utils/utils';

export class ClientDTO extends Serializable {
    id: string;
    name: string;
    country: string;
    city: string;
    address: string;
    province: string;
    phone: string;
    email: string;
    contactName: string;
    price: number;
    expirationTime: string;
    createLicense: string;

    constructor() {
        super();
    }
    
    get createLicenseFormat() {
        let date = new Date(this.createLicense);
        return Utils.dateToString(date);
    }

    get expirationTimeFormat() {
        let date = new Date(this.expirationTime);
        return Utils.dateToString(date);
    }
}
